export enum CustomFormTypeEnum {
  Reservation = 0,
  Request = 1,
  Experiment = 2,
  Alert = 3,
  AlertType = 4,
  ServiceGroup = 5,
  Quiz = 6,
}
